import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { SectionSubmissionDates } from '@/courses/models/section.model';
import { EdContextMenuModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import { Holiday } from '@/tools/models/holiday.model';
import { SectionSchooolCalendarProvider } from '../providers/section-school-calendar.provider';

@Component({})
export default class SectionSchoolCalendarMixin extends Vue {

  @Prop() readonly params: any;
  @Prop() readonly defaultDueDateForTasks: any;
  @Prop() readonly defaultLastDateForTasks: any;
  @Prop() readonly submissionDates: SectionSubmissionDates;

  public form: any = null;

  get holidaysDates(): string[] {
    let dates: string[] = [];
    let holidays: Holiday[] = SectionSchooolCalendarProvider.holidays;
    holidays.forEach(h => {
      dates.push(h.startDate);
      if(h.endDate) {
        dates.push(h.endDate);
      }
    });
    return dates;
  }

  get hasSchoolDays() {
    return SectionSchooolCalendarProvider.hasSchoolDays;
  }

  get allowedDatesToLastDate() {
    let allowedDates = SectionSchooolCalendarProvider.getCurrentSchoolDays(this.params.minDate);
    if(this.form && this.form.dueDate) {
      const i = allowedDates.findIndex(d => d == this.form.dueDate.value);
      allowedDates.splice(0, i);
    }
    return allowedDates;
  }

  get defaultDueDate() {
    return SectionSchooolCalendarProvider.getDefaultDueDate(this.defaultDueDateForTasks, this.params.minDate);
  }

  get defaultLastDate() {
    return SectionSchooolCalendarProvider.getDefaultLastDate(
      '', 
      this.defaultDueDate,
      this.defaultLastDateForTasks,
      this.defaultDueDateForTasks,
      this.form,
      this.params.minDate
    )
  }

  get dueDateDisclamer() {
    return SectionSchooolCalendarProvider.getDateDisclamer(
      this.defaultDueDate,
      this.form && this.form.dueDate && this.defaultDueDate ? true : false,
      'dueDate',
      'dueDateAuto',
      this.params.edition,
      this.submissionDates,
      this.form
    );
  }

  get lastDateDisclamer() {
    return SectionSchooolCalendarProvider.getDateDisclamer(
      this.defaultLastDate,
      this.form && this.form.dueDate && this.defaultLastDate ? true : false,
      'dueDate',
      'dueDateAuto',
      this.params.edition,
      this.submissionDates,
      this.form
    );
  }

  get currentSchoolDays(): string[] {
    return SectionSchooolCalendarProvider.getCurrentSchoolDays(this.params.minDate);
  }

  isHomeworkChanged(value) {
    SectionSchooolCalendarProvider.onHomeworkChanged(value, this.form, this.defaultDueDate, this.defaultLastDate);
  }

  getEventsColor(date: string) {
    return SectionSchooolCalendarProvider.getEventsColor(date, SectionSchooolCalendarProvider.holidays);
  }

  hideSchoolDay() {
    this.$EdContextMenu.close();
  }

  showSchoolDay({date, position}: { date: string, position: { x: number, y: number } }) {
    let dates = SectionSchooolCalendarProvider.schoolDaysList;
    let day = dates.findIndex(d => d == date);
    let text = `${this.$i18n.t('tools.schooldays.schoolDay')}: ${day + 1}`;
    this.$EdContextMenu.show(new EdContextMenuModel({
      position: { x: position.x, y: position.y },
      options: [{ id: date, text }],
    }));
  }

  onDueDateChange(dueDate) {
    if(!dueDate) {
      this.form.set('lastDate', '');
    } else {
      setTimeout(() => {
        const defaultLastDate = SectionSchooolCalendarProvider.getDefaultLastDate(
          dueDate, 
          this.defaultDueDate,
          this.defaultLastDateForTasks,
          this.defaultDueDateForTasks,
          this.form
        );
        if(defaultLastDate) {
          this.form.set('lastDate', defaultLastDate);
        }        
      }, 5);
    }
  }

}